import { createContext } from 'react'

const ConcesionesContext = createContext();

export default ConcesionesContext;